import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '#services/shared/shared.module';
import { LoadingIndicatorService } from '#services/shared/loading-indicator.service';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { DocumentationComponent } from './documentation/documentation.component';
import { SynchronizationComponent } from './synchronization/synchronization.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '#components/components.module';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { AccordionModule } from 'primeng/accordion';
import { TableModule } from 'primeng/table';
import { DataViewModule } from 'primeng/dataview';
import { ChartModule } from 'primeng/chart';
import { ConfirmationService,MessageService } from 'primeng/api';
import { DialogModule } from 'primeng/dialog';
import { ActivityReportComponent } from './reporting/activity-report/activity-report.component';
import { ComplianceReportComponent } from './reporting/compliance-report/compliance-report.component';
import { ActivityAuditLogComponent } from './auditLog/activity.audit.log.component';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [
        LoginComponent,
        HomeComponent,
        DocumentationComponent,
        SynchronizationComponent,
        ActivityReportComponent,
        ComplianceReportComponent,
        ActivityAuditLogComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        ComponentsModule,
        HttpClientModule,
        TranslateModule,
        // PrimeNG
        TooltipModule,
        InputTextModule,
        ButtonModule,
        SelectModule,
        MultiSelectModule,
        SelectButtonModule,
        AccordionModule,
        TableModule,
        DataViewModule,
        ChartModule,
        DialogModule
    ],
    providers: [
        LoadingIndicatorService,
        MessageService,
        ConfirmationService
    ]
})

export class PagesModule { }
